import { Card, CardContent } from "@/components/ui/card";

const FAQComponent = () => {
  return (
    <section className="py-12 px-4 custom-bg-color-02">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-3xl font-bold text-center mb-12 custom-color-01">
          Dúvidas frequentes
        </h3>

        <div className="space-y-6">
          {[
            {
              question: "Preciso ter formação teológica para participar?",
              answer:
                "Não. O congresso é acessível a todos os cristãos comprometidos.",
            },
            {
              question:
                "O conteúdo é relevante para problemas graves como depressão?",
              answer:
                "Sim. Abordamos questões emocionais e espirituais profundas, sempre à luz das Escrituras.",
            },
            {
              question: "Receberei certificado?",
              answer: "Sim, tanto na modalidade presencial quanto online.",
            },
            {
              question: "Por quanto tempo terei acesso ao conteúdo?",
              answer: "6 meses após o evento.",
            },
            {
              question: "Posso aplicar o que aprender mesmo não sendo pastor?",
              answer:
                "Sim. Os princípios são úteis para qualquer cristão que deseja servir e aconselhar biblicamente.",
            },
            {
              question: "Como funciona o desconto para grupos e igrejas?",
              answer:
                "Para 5 inscrições, 10% de desconto. Para igrejas da Grande BH, oferecemos workshop presencial adicional. Entre em contato para detalhes.",
            },
          ].map((faq, index) => (
            <Card
              key={index}
              className="custom-bg-color-01 custom-color-03 custom-border-color-03"
            >
              <CardContent className="p-6">
                <h4 className="font-semibold text-lg mb-3 custom-color-04">
                  {faq.question}
                </h4>
                <p>{faq.answer}</p>
                <img src="" alt="" />
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
export default FAQComponent;
